import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import useModalState from '../useModalState.js';
import Modal from '../../components/Modal/index.js';
import Button from '../../components/Button/index.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function removeElementsWithUndefinedValue(obj) {
  if (obj === undefined) {
    return obj;
  }

  const newObj = { ...obj
  };
  Object.keys(newObj).forEach(key => {
    if (obj[key] === undefined) {
      delete newObj[key];
    }
  });
  return newObj;
}

const defaultOptions = {
  message: 'Are you sure?',
  heading: 'Confirmation',
  confirmButtonContent: 'Yes',
  denyButtonContent: 'No'
};

function useConfirmation(options, extraProps) {
  var _Button, _Button2;

  const {
    showConfirmationInitially = false,
    onConfirm,
    onDeny,
    onResolve,
    heading,
    message,
    denyButtonActions,
    denyButtonContent,
    denyButtonIcons,
    denyButtonClassName,
    confirmButtonActions,
    confirmButtonContent,
    confirmButtonIcons,
    confirmButtonClassName
  } = { ...defaultOptions,
    ...removeElementsWithUndefinedValue(options)
  };
  const [showModal, setShowModalTrue, setShowModalFalse, ctx] = useModalState(showConfirmationInitially);
  const handleCancelButtonClick = React.useCallback(() => {
    setShowModalFalse();

    if (onDeny) {
      onDeny(ctx);
    }

    if (onResolve) {
      onResolve(false, ctx);
    }
  }, [setShowModalFalse, onDeny, onResolve, ctx]);
  const handleConfirmButtonClick = React.useCallback(() => {
    setShowModalFalse();

    if (onConfirm) {
      onConfirm(ctx);
    }

    if (onResolve) {
      onResolve(true, ctx);
    }
  }, [setShowModalFalse, onResolve, onConfirm, ctx]);
  const modal = React.useMemo(() => {
    if (!showModal) {
      return null;
    }

    const {
      footerActions,
      ...modalProps
    } = extraProps ?? {};
    return /*#__PURE__*/React.createElement(Modal, _extends({}, modalProps, {
      heading: heading,
      freeHeight: true,
      size: "small",
      hideCloseButton: true // onCloseButtonClick={handleCancelButtonClick}
      ,
      footerActions: /*#__PURE__*/React.createElement(React.Fragment, null, footerActions, _Button || (_Button = /*#__PURE__*/React.createElement(Button, {
        actions: denyButtonActions,
        className: denyButtonClassName,
        icons: denyButtonIcons,
        name: "deny-button",
        onClick: handleCancelButtonClick,
        variant: "secondary"
      }, denyButtonContent)), _Button2 || (_Button2 = /*#__PURE__*/React.createElement(Button, {
        actions: confirmButtonActions,
        autoFocus: true,
        className: confirmButtonClassName,
        icons: confirmButtonIcons,
        name: "confirm-button",
        onClick: handleConfirmButtonClick
      }, confirmButtonContent)))
    }), message);
  }, [showModal, extraProps, denyButtonIcons, denyButtonActions, denyButtonContent, confirmButtonActions, confirmButtonContent, confirmButtonIcons, message, heading, handleCancelButtonClick, handleConfirmButtonClick, denyButtonClassName, confirmButtonClassName]);
  return [modal, setShowModalTrue];
}

export { useConfirmation as default };
//# sourceMappingURL=index.js.map
